import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnalysisPlan } from 'src/app/models/analysis-plan';
import {
  formatterDollar,
  formatterPercent,
  parserDollar,
  parserPercent,
} from 'src/app/utils/app-common';

@Component({
  selector: 'app-analysis-form-client-goal',
  templateUrl: './analysis-form-client-goal.component.html',
  styleUrls: ['./analysis-form-client-goal.component.scss'],
})
export class AnalysisFormClientGoalComponent implements OnInit {
  @Input() analysisPlan!: AnalysisPlan;

  constructor() {}

  ngOnInit(): void {}

  formatterDollar = formatterDollar;
  parserDollar = parserDollar;
  formatterPercent = formatterPercent;
  parserPercent = parserPercent;

  @Output() formDataChange = new EventEmitter<void>();

  emitDataChange() {
    this.formDataChange.emit();
  }
}
